var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_514_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0887 18.4394L73.5788 45.3421L102.721 47.9563C104.008 48.0674 104.959 49.2001 104.847 50.4857C104.794 51.1123 104.497 51.6586 104.058 52.0425L104.059 52.0432L82.0123 71.2948L88.5328 99.829C88.8217 101.089 88.0334 102.344 86.7735 102.633C86.1278 102.781 85.4843 102.646 84.9702 102.31L59.9285 87.3392L34.8072 102.358C33.6986 103.021 32.2624 102.66 31.5992 101.551C31.2767 101.013 31.197 100.396 31.3264 99.829H31.3242L37.8455 71.2948L15.7983 52.044C14.8265 51.1935 14.7285 49.7164 15.5782 48.7446C16.0104 48.2502 16.6056 47.9826 17.2126 47.9497L46.2783 45.3421L57.7743 18.4247C58.2803 17.235 59.6551 16.6814 60.8448 17.1875C61.4298 17.4361 61.8612 17.8953 62.0887 18.4394ZM69.8194 48.4601L59.9285 25.3L50.0369 48.4601L50.034 48.4594C49.7064 49.2279 48.9759 49.7946 48.0852 49.8721L22.999 52.1229L41.8791 68.609C42.5731 69.1501 42.9306 70.0627 42.7215 70.9782L37.1099 95.5321L58.6861 82.6321C59.4072 82.181 60.349 82.1407 61.13 82.608L82.7479 95.5321L77.137 70.9782L77.1392 70.9768C76.955 70.1658 77.2094 69.2817 77.8793 68.696L96.8589 52.1229L71.902 49.8838C71.0187 49.8561 70.1887 49.3266 69.8194 48.4601Z",
    fill: "#7801EF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.59b1caa61dde399043d2d11e23a9c3ef.svg";
export { ForwardRef as ReactComponent };